import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-285e1b06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "end__page" }
const _hoisted_2 = {
  key: 0,
  class: "tp-modal"
}
const _hoisted_3 = { class: "tp-modal__box" }
const _hoisted_4 = { class: "tp-modal__box-inner" }
const _hoisted_5 = { class: "tp-modal__box-inner-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Имя и фамилия:", -1))
const _hoisted_7 = { class: "tp-modal__email-div" }
const _hoisted_8 = {
  key: 0,
  class: "tp-modal__error"
}
const _hoisted_9 = { class: "tp-modal__box-inner-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Ваша почта:", -1))
const _hoisted_11 = { class: "tp-modal__email-div" }
const _hoisted_12 = {
  key: 0,
  class: "tp-modal__error"
}
const _hoisted_13 = { class: "tp-modal__box-inner-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Ваш телефон:", -1))
const _hoisted_15 = { class: "tp-modal__email-div" }
const _hoisted_16 = {
  key: 0,
  class: "tp-modal__error"
}
const _hoisted_17 = { class: "tp-modal__box-inner-row" }
const _hoisted_18 = { class: "tp-modal__box-inner-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 6L6 19",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 6L19 19",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "end__page-inner" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "end__page-header" }, "Поздравляем!", -1))
const _hoisted_23 = {
  key: 0,
  class: "end__page-text"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://tproger.ru/interactive",
  target: "_blank",
  class: "link-doc"
}, "другие игры Tproger.", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = {
  key: 1,
  class: "end__page-text"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = {
  key: 3,
  class: "modal__message"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "final__menu" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "restart__link",
  target: "_blank"
}, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "about-selectel-stand"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tp_button = _resolveComponent("tp-button")!
  const _component_tp_share = _resolveComponent("tp-share")!
  const _component_selectel = _resolveComponent("selectel")!
  const _component_tp_background_blur = _resolveComponent("tp-background-blur")!
  const _component_tp_box = _resolveComponent("tp-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tp_box, null, {
      default: _withCtx(() => [
        (_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "tp-modal__input",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.name]
                      ]),
                      (_ctx.showErrorName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Введите ваше имя и фамилию"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "tp-modal__input",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.email]
                      ]),
                      (_ctx.showErrorEmail)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Введите корректный email"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "tp-modal__input",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.phone]
                      ]),
                      (_ctx.showErrorPhone)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Введите корректный телефон"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_tp_button, {
                      class: "tp-modal-button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendEmail()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Отправить")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", {
                      class: _normalizeClass(_ctx.agreeTermClass)
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.agreeTerm) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.agreeTerm]
                      ]),
                      _createTextVNode("Я даю согласие на обработку персональных данных")
                    ], 2)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tp-modal__close",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showModal = false))
                }, _hoisted_20)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          (_ctx.isConf==='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createTextVNode(" Если чувствуете в себе силы, сыграйте в "),
                _hoisted_24,
                _hoisted_25
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isSend && _ctx.isConf==='conf1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createTextVNode(" Осталось нажать на кнопку и Тирекс почти у вас! "),
                _hoisted_27
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isSend && _ctx.isConf==='conf1')
            ? (_openBlock(), _createBlock(_component_tp_button, {
                key: 2,
                class: "promocode__button",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showModalDialog()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Участвовать в розыгрыше")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isSend && _ctx.isConf==='conf1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                (!_ctx.statusOK)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Вы уже отправили заявку"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_30, "Ваша заявка принята"))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_tp_share),
          (_ctx.isConf==='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
            : _createCommentVNode("", true),
          (_ctx.isConf==='conf1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, " Подробности розыгрыша уточняйте на стенде Selectel "))
            : _createCommentVNode("", true),
          _createVNode(_component_selectel, { class: "end__page-selectel-logo" })
        ]),
        _createElementVNode("div", {
          class: "blur__background end-blur__background",
          style: _normalizeStyle(`background: url(${require('@/assets/blue-blur.svg')}) no-repeat center`)
        }, null, 4),
        _createVNode(_component_tp_background_blur)
      ]),
      _: 1
    })
  ]))
}